<!--
  File name: Redirect.vue
  Program Description:
    - Component that handles redirect when needed in the system
    - This is used when the user is already logged in and tries to go to the login page
    - Redirected to the dashboard page
-->
<template>
  <v-progress-linear
    class="here"
    height="100"
    color="purple darken-2"
    indeterminate
  />
</template>

<script>
import { authSocket } from '@/socket'
const Encryption = require('./class/Encryption')
const decryptor = new Encryption()

export default {
  name: 'Redirect',
  async created () {
    try {
      const { query } = this.$route
      const { a: queryCredentials, u: username } = query
      let name = 'Login'

      if (queryCredentials && username) {
        authSocket.emit('getKey', username, async (err, key) => {
          if (this.$s.session && (!this.$s.session.userRole.includes('guest') && this.$s.session.userType === 'External')) {
            name = 'AdminDashboard'
            this.$router.push({
              name
            })
            return
          }

          if (err) {
            this.$store.dispatch('showAlert', {
              message: err,
              type: 'error'
            })
            this.$router.push({
              name
            })
            return
          }

          const decrypt = decryptor.decrypt(queryCredentials, key)
          const [decryptedUsername, decryptedPassword] = decrypt.split(',')
          const creds = {
            username: decryptedUsername,
            password: decryptedPassword,
            redirect: true
          }
          const resp = await this.$s.login(creds, true)
          const jdata = resp.jData

          if (resp.ok) {
            name = 'AdminDashboard'
          } else {
            this.$store.commit({
              type: 'redirect/SET_STORE_STATE',
              stateName: 'fail',
              value: true
            })
            this.$store.dispatch('showAlert', {
              message: jdata.error,
              type: 'error'
            })
          }

          this.$router.push({
            name
          })
        })
      }
    } catch (err) {
      this.$store.commit({
        type: 'redirect/SET_STORE_STATE',
        stateName: 'fail',
        value: true
      })
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>
